import React from 'react';
import ReactDOM from "react-dom";
import {Wrapper} from "@atttomyx/react-components";
import App from "./app";
import {storage} from "@atttomyx/react-utils";
import {themes} from "@atttomyx/shared-constants";
import {BRANDING_LIGHT, NAMESPACE} from "./constants";

storage.setNamespace(NAMESPACE);

ReactDOM.render(
    <Wrapper theme={themes.LIGHT}
             branding={BRANDING_LIGHT}
    >
        {(onThemeChange, snackbar, dimensions) =>
            <App
                onThemeChange={onThemeChange}
                snackbar={snackbar}
                dimensions={dimensions}
            />}
    </Wrapper>,
    document.getElementById('root')
);
